/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { FolderApi } from 'tweakpane';
import type { App } from '../App';
import { DevToolsPlugin, type SectionConfig } from '../devTools/DevToolsPlugin';
import type { Scene } from '../SceneManager';

export interface DebugSectionConfig extends SectionConfig {
  readonly id: string;
  showOnSceneActivate?(scene: Scene): boolean;
}

interface DebugSection {
  readonly section: FolderApi;
  readonly config: DebugSectionConfig;
}

export class DebugPlugin extends DevToolsPlugin {
  private readonly sections: DebugSection[] = [];

  constructor(
    private readonly app: App,
    private readonly sectionConfigs: DebugSectionConfig[],
  ) {
    super();
  }

  // post
  public init(): void {
    const { sectionConfigs, sections } = this;

    sectionConfigs.forEach((config) => {
      const { section } = this.addSection(config);
      sections.push({ section, config });
    });

    // Activate sections automatically on Scene Change if relevant.
    const { sceneManager } = this.app.controller;
    sceneManager.onSceneActivated.connect((scene: Scene) => {
      this.onSceneChanged(scene);
    });
    if (sceneManager.activeScene) this.onSceneChanged(sceneManager.activeScene);
  }

  private showSections(sectionId: string[]): void {
    this.sections.forEach(({ section, config }) => {
      section.hidden = !sectionId.includes(config.id);
    });
  }

  private onSceneChanged(scene: Scene): void {
    this.showSections(
      this.sections
        .filter(({ config }) => !config.showOnSceneActivate || config.showOnSceneActivate?.(scene))
        .map(({ config }) => config.id),
    );
  }

  public updateSectionTitle(sectionId: string, newTitle: string): void {
    const section = this.sections.find(({ config }) => config.id === sectionId);
    if (section) {
      section.section.title = newTitle;
    }
  }
}
